/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from 'constants/Colors';
import { FiraSansBold, Text } from 'components/Text';
import { Breakpoints } from "../../../../constants/Breakpoints";


const Content = styled.div`
  background: ${Colors.WHITE};
  border: 1px solid ${Colors.BLUE};
  background: #fff;
  margin: 0;
  border-radius: 10px;
  box-shadow: 0px 17px 17px 6px #5f5f5f1a;
  
  @media screen and (min-width: ${Breakpoints.sm}) {
    margin-top: 40px;
    margin-bottom: 60px;
    border-radius: 20px;
  }
`;

const Heading = styled.div`
  background: ${Colors.BLUE};
  color: ${Colors.WHITE};
  font-weight: ${FiraSansBold};
  font-family:'Fira Sans', sans-serif;
  text-transform: uppercase;
  font-size: 16px;
  border-radius: 10px 10px 0 0;
  padding: 10px;
  display: flex
  justify-content: space-between
  align-items: center
  
  @media screen and (min-width: ${Breakpoints.sm}) {
    padding: 17px 25px;
    border-radius: 15px 15px 0px 0px;
  }
`;

const HeaderButton = styled.button`
  padding-left: 32px;
  padding-right: 32px;
  height: 40px;
  background: ${Colors.WHITE};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: ${Colors.GREEN};
  cursor: pointer; 
`;

export const ButtonContainer = styled.div`
  text-transform: none;
  @media (min-width: ${Breakpoints.sm}) {
    display: flex;
    align-items: center;
  }
  
`

const TitleChart = styled(Text)`
  font-size: 16px;
  display: block;
  margin-top: 30px;
  margin-left: 10px
`;

const TitleCalendar = styled(Text)`
  font-size: 16px;
  display: block;
  margin-top: 30px;
  margin-left: 10px
  margin-bottom: 20px;
`;

const Legend = styled.div`
  height: 60px;

  .content{
    p{
      width: 50%;
      display: inline-block;
      font-size: 13px;
      color: #777;
    }
    p:first-child{
      text-align: right;
    }
    span{
      width: 10px;
      height: 10px;
      margin-right: 5px;
      display: inline-block;
      margin-left: 10px;
    }
  }
`;

const Main = styled.div`
  margin-left: 30px;
  margin-right: 0px;
  padding-bottom: 16px;
`;

export const AccessButtonHelperText = styled.div`
  display: flex;
  justify-content: center;
  @media (max-width: ${Breakpoints.sm}) {
    font-size: 9px;
    line-height: 10pt;
  }
  @media (min-width: ${Breakpoints.sm}) {
    margin-right: 8px
  }
`


export { Content, Heading, TitleChart, TitleCalendar, Legend, Main, HeaderButton };
